import React from 'react';
import {ReactComponent as CashFlowMgIcon} from '~/assets/icons/menu/CashFlowMg/CashFlowBlack.svg';
import { LinearProgress } from '@material-ui/core';
import LogoAnimation from '@views/Testing/components/LogoAnimation'
const CashFlowPage =React.lazy(()=>import('cashflow/CashFlowPage'))

// error boundary
import ErrorBoundary from '@components/ErrorBoundary';
import { mainColor } from '~/assets/jss/material-dashboard-react/components/sidebarStyle';
import SVGIcon from '@components/SvgIcon';

const WithSuspError = (props) => {
  return (
    <ErrorBoundary>
       <React.Suspense fallback={<LogoAnimation/>}>
         {props.children}
       </React.Suspense>
    </ErrorBoundary>
  );
};

const rootRoutes = [
  {
    path: "/cash",
    name: "Cash Flow",
    rtlName: "التدفقات النقدية",
    icon:  ()=> <SVGIcon style={{color:mainColor}} fontSize={'2.1rem'} viewBox={'0 0 1100 1100'} svg={CashFlowMgIcon}/> ,
    component: <WithSuspError><CashFlowPage/></WithSuspError>,
    layout: "/admin",
    navBarName:'Cash Flow'
  }
];

export default rootRoutes;